import axios from 'axios';
import {backendHost} from '../../config';

export const getTransactionsList = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/transaction`, {params});
};